import React, { FC } from 'react';
import { DashboardLayout } from '../dashboard-layout';
import {
  AccountStatisticsLoading,
  ActivityLogLoading,
  DashboardHeaderLoading,
  KeyMetricsLoading,
  PerformanceChartLoading,
  ProgressOverviewLoading,
} from '../sections';

export const DashboardLoading: FC = () => {
  return (
    <DashboardLayout>
      <ProgressOverviewLoading />
      <DashboardHeaderLoading />
      <PerformanceChartLoading />
      <KeyMetricsLoading />
      <ActivityLogLoading />
      <AccountStatisticsLoading />
    </DashboardLayout>
  );
};
